import './HouseMoneySidesheet.scss';
import { formatToNaira } from '../../../../../../helpers/utils';
import { WalletSidesheetProps } from '../../../../../../types';

const HouseMoneySidesheet = ({ data }: WalletSidesheetProps) => {
  const nubanCards =
    data.nubans.length > 0 ? data.nubans.filter((account: { deleted: boolean }) => !account.deleted) : [];

  return (
    <>
      <div className="house-money-sidesheet">
        <h1 className="heading">User HouseMoney&trade; Details</h1>

        <div className="hm-balance">
          <p>Total Balance</p>
          <h1 className="plus-jakarta-sans-font">{formatToNaira(data?.houseMoneyBalance ?? 0)}</h1>
        </div>

        <div className="hm-dates">
          <div className="date">
            <p className="">Start Date</p>
            <p>{data?.startDate}</p>
          </div>
          <div className="date">
            <p className="">Rent Due</p>
            <p>{data?.withdrawalMonth || 'Not Set'}</p>
          </div>
          <div className="date">
            <p className="">Rent Amount</p>
            <p>{formatToNaira(data?.targetAmount ?? 0)}</p>
          </div>
        </div>
        {nubanCards.length && (
          <div className="virtual-accounts">
            <h3>Virtual Accounts</h3>
            <div className="cards">
              {nubanCards.map((nuban: any, index: any) => {
                return (
                  <div className="card" key={index + 1}>
                    <div className="card-data">
                      <p className="bank-name">{nuban.bankName}</p>
                      <p className="bank-number">{nuban.accountNumber}</p>
                      {nuban.deleted && <p className="deleted">Deleted</p>}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default HouseMoneySidesheet;
